import { render, staticRenderFns } from "./TifLiquidacionesDetPlaca.vue?vue&type=template&id=22ca979e"
import script from "./TifLiquidacionesDetPlaca.vue?vue&type=script&lang=js"
export * from "./TifLiquidacionesDetPlaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports